import { Component, Input, OnInit } from '@angular/core';
import { EventRead } from '../../shared/event-read.model';
import { DialogService, UtilService } from '../../../shared/index';
import { BenefitService } from '../../../benefits/shared/benefit.service';
import { EventPriceBenefit } from '../../../benefits/shared/event-price-benefit.model';
import { EventBenefit } from '../../../benefits/shared/event-benefit.model';
import { BenefitType } from '../../../benefits/shared/benefit-type.model';
import { AdjustmentTypeService } from '../../../revenue/shared/adjustment-types/adjustment-type.service';
import { AdjustmentType } from '../../../revenue/shared/adjustment-types/adjustment-type.model';
import { EventV4ItemService } from '../../shared/items/event-v4-item.service';
import { EventItemSummary } from '../../shared/items/event-item-summary.model';
import { EventV4BenefitService } from '../../shared/benefits/event-v4-benefit.service';

@Component({
  selector: 'wl-event-v4-settings-benefits',
  templateUrl: 'event-v4-settings-benefits.component.html',
  providers: [BenefitService, AdjustmentTypeService],
    standalone: false
})
export class EventV4SettingsBenefitsComponent implements OnInit {
  public _dialogService: DialogService;
  public _event: EventRead = new EventRead();
  public _loadingAssets: boolean = false;
  public _error: string = '';
  public showModal = false;

  @Input() public get event(): EventRead {
    return this._event;
  }
  public set event(value: EventRead) {
    this._event = value;
    if (!this._event) {
      return;
    } else {
      this.getBenefits();
    }
  }

  public eventBenefits: Array<EventBenefit>;
  public loadingBenefits: boolean;
  public isSaving: boolean;
  public selectedEventBenefit: EventBenefit;
  public benefitTypes: Array<BenefitType>;
  public adjustmentTypes: Array<AdjustmentType>;
  public showBenefitHelp: boolean;
  public _eventItems: Array<EventItemSummary> = [];

  public constructor(
    private _benefitService: BenefitService,
    private _adjustmentTypeService: AdjustmentTypeService,
    private _utilService: UtilService,
    private _eventBenefitService: EventV4BenefitService,
    public _eventItemService: EventV4ItemService
  ) {
    this._event = new EventRead();

    this.eventBenefits = new Array<EventBenefit>();
    this.benefitTypes = new Array<BenefitType>();
    this.adjustmentTypes = new Array<AdjustmentType>();

    this.loadingBenefits = false;
    this.isSaving = false;
    this.showBenefitHelp = false;

    this.selectedEventBenefit = new EventBenefit();
  }

  ngOnInit() {
    let promises: Promise<any>[] = [];

    this._error = '';
    this._loadingAssets = true;

    promises.push(
      this._benefitService.getBenefitTypes().then((data: Array<BenefitType>) => {
        this.benefitTypes = data.filter((btype) => btype.IsEventBenefit);
        this.showBenefitHelp = !this.benefitTypes.length;
      })
    );

    promises.push(this._eventItemService.getEventItems(this.event.EventId).then((x) => (this._eventItems = x)));

    promises.push(
      this._adjustmentTypeService.getAdjustmentTypes().then((data: Array<AdjustmentType>) => {
        this.adjustmentTypes = data;
      })
    );

    Promise.all(promises).then(
      () => (this._loadingAssets = false),
      (error) => {
        this._loadingAssets = false;
        this._error = this._utilService.extractErrorMessage(error);
      }
    );
  }

  public getBenefits() {
    this.loadingBenefits = true;
    this._eventBenefitService.getEventBenefits(this._event.EventId, true).then(
      (data: Array<EventBenefit>) => {
        this.eventBenefits = data;

        for (let eventBenefit of this.eventBenefits) {
          this.addAvailableItemsToEventBenefit(eventBenefit);
        }
        this.loadingBenefits = false;
      },
      () => {
        this.loadingBenefits = false;
      }
    );
  }

  public addAvailableItemsToEventBenefit(benefit: EventBenefit) {
    for (let item of this._eventItems) {
      if (this.hasEventItem(item.EventItemId, benefit) == false) {
        let eventItemToAdd = new EventPriceBenefit();
        eventItemToAdd.EventBenefitId = benefit.EventBenefitId;
        eventItemToAdd.EventPriceId = item.EventItemId;
        eventItemToAdd.EventPriceDescr = item.Descr;
        eventItemToAdd.Selected = false;
        benefit.EventItems.push(eventItemToAdd);
      }
    }
  }

  public hasEventItem(eventItemId: number, benefit: EventBenefit) {
    let bol = false;
    for (let item of benefit.EventItems) {
      if (item.EventPriceId == eventItemId) {
        bol = true;
        break;
      }
    }

    return bol;
  }

  public newEventBenefit() {
    this.selectedEventBenefit = new EventBenefit();
    this.selectedEventBenefit.EventId = this._event.EventId;
    this.selectedEventBenefit.LimitAmount = 1;

    if (this.benefitTypes.length > 0) {
      this.selectedEventBenefit.BenefitTypeId = this.benefitTypes[0].Id;
    }

    if (this.adjustmentTypes.length > 0) {
      this.selectedEventBenefit.AdjustmentTypeId = this.adjustmentTypes[0].AdjustmentTypeId;
    }

    this.addAvailableItemsToEventBenefit(this.selectedEventBenefit);
    //default to all selected
    for (let item of this.selectedEventBenefit.EventItems) {
      item.Selected = true;
    }
    this.showModal = true;
  }

  public editEventBenefit(benefit: EventBenefit) {
    this.selectedEventBenefit = benefit;
    this.addAvailableItemsToEventBenefit(this.selectedEventBenefit);
    this.showModal = true;
  }

  public saveEventBenefit() {
    this.isSaving = true;

    let eventBenefitToUpdate = new EventBenefit();
    this._utilService.mapSafe(this.selectedEventBenefit, eventBenefitToUpdate);
    let selectedEventItems = new Array<EventPriceBenefit>();
    for (let item of this.selectedEventBenefit.EventItems) {
      if (item.Selected == true) {
        let itemToUpdate = new EventPriceBenefit();
        this._utilService.mapSafe(item, itemToUpdate);
        selectedEventItems.push(itemToUpdate);
      }
    }
    eventBenefitToUpdate.EventItems = selectedEventItems;

    if (this.selectedEventBenefit.EventBenefitId > 0) {
      this._eventBenefitService.updateEventBenefit(eventBenefitToUpdate).then(
        () => {
          this.getBenefits();
          this.showModal = false;
          this.isSaving = false;
        },
        () => {
          this.isSaving = false;
        }
      );
    } else {
      this._eventBenefitService.createEventBenefit(eventBenefitToUpdate).then(
        () => {
          this.getBenefits();
          this.showModal = false;
          this.isSaving = false;
        },
        () => {
          this.isSaving = false;
        }
      );
    }
  }

  public deleteEventBenefit(benefit: EventBenefit) {
    this._eventBenefitService.deleteEventBenefit(benefit.EventBenefitId).then(
      () => {
        this.getBenefits();
      },
      () => {
        this.loadingBenefits = false;
      }
    );
  }

  public onBenefitTypeChange = (data: string): void => {
    //the option comes thru as a string convert to int
    this.selectedEventBenefit.BenefitTypeId = parseInt(data);
  };

  public onLimitTypeChange = (data: string): void => {
    //the option comes thru as a string convert to int
    this.selectedEventBenefit.LimitType = parseInt(data);
  };

  public onAdjustmentTypeChange = (data: string): void => {
    //the option comes thru as a string convert to int
    this.selectedEventBenefit.AdjustmentTypeId = parseInt(data);
  };
}
